import { useEffect } from 'react';
import router from 'next/router';

import { PageLayoutActions } from 'layout/state/pageLayoutReducer';
import { usePageLayoutDispatch, usePageLayoutState } from 'shared/hooks';

export const usePutBackHeaderOnPageChange = () => {
  const dispatch = usePageLayoutDispatch();
  const { isHeaderVisible } = usePageLayoutState();

  useEffect(() => {
    const handleRouteChangeStart = () => {
      if (!isHeaderVisible) {
        dispatch({ type: PageLayoutActions.setIsHeaderVisible, payload: true });
      }
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  });
};
